import { useEffect, useState } from 'react'
import './style.scss'
import { InstructorProfileData } from '../../server/types'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import { instructorProfileConnector } from '../../server/connector/instructorProfileConnector'
import { instructorStateData } from '../../data/instructorStateData'
import { getProfilePicPathArr } from '../../constants/instructorConstants'
import { userStateData } from '../../data/userStateData'
import { PAGE_URLS } from '../../constants/hrefLinks'
import HeaderAppProfilePics from '../../sections/header/HeaderAppProfilePics'

function AppInstructorProfilePics() {
	const [instructorProfileData, setInstructorProfileData] = useState<InstructorProfileData | undefined>(instructorStateData.profileData)
	const [profilePicPaths, setProfilePicPaths] = useState<string[] | undefined>(undefined)

	useEffect(() => {
		requestProfile()
	}, [])

	const requestProfile = () => {
		const querySting: string = window.location.search;
		const urlParams: URLSearchParams = new URLSearchParams(querySting)
		const profileId: string | null = urlParams.get('id')

		if (instructorProfileConnector.requestInProgress) {
			console.log('[AppInstructorProfilePics] - requestProfile() called while requestInProgress')
		} else {
			if (profileId) {
				instructorProfileConnector.getInstructorProfileRequest(profileId).then((successRequest) => {
					if (instructorStateData.profileData === undefined) {
						console.log('WARNING - [AppInstructorProfile] - requestProfile() failed, undefined result')
					} else {
						setInstructorProfileData(instructorStateData.profileData)
						setProfilePicPaths(getProfilePicPathArr(instructorStateData.profileData.profile_pics))
					}
					if (!successRequest) {
						console.log('WARNING - [AppInstructorProfile] - requestProfile() failed')
					}
				})
			}
		}
	}

	const bookNowButtonClickHandler = () => {
		if (userStateData.loggedIn) {
			const querySting: string = window.location.search;
			const urlParams: URLSearchParams = new URLSearchParams(querySting)
			const profileId: string | null = urlParams.get('id')
			// TODO: remove price setting from url string on backend
			// check to make sure price is set so it can be added to the url
			const priceInPennies: string = instructorProfileData?.price ? instructorProfileData?.price.replace('.', '') : '0'
			window.location.replace(`${PAGE_URLS.CREATE_NEW_CHAT}?instructorId=${profileId}&cost=${priceInPennies}`)
		} else {
			window.location.replace(`${PAGE_URLS.LOG_IN}`)
		}
	}

	return (
		<>
			<div className='section-wrap'>
				{instructorProfileData &&
					<HeaderAppProfilePics 
						instructorName={instructorProfileData.name}
						instructorId={instructorProfileData.id}
					/>
				}
			</div>
			<div className='section-seperator p-r app-instructor-pics-page-extend-margin'>
				{profilePicPaths &&
					<>
						<div className='app-instructor-profile-image-wrap'>
							<img
								src={profilePicPaths[0]}
								className='app-instructor-profile-pics-image-img'
								alt='Instructor Profile'
							/>
						</div>
						<div className='app-instructor-profile-image-wrap-small'>
							<img
								src={profilePicPaths[1]}
								className='app-instructor-profile-pics-image-img-small'
								alt='Instructor Profile'
							/>
							<img
								src={profilePicPaths[2]}
								className='app-instructor-profile-pics-image-img-small'
								alt='Instructor Profile'
							/>
						</div>
						<div className='app-instructor-profile-image-content-top-bar' />
					</>
				}
			</div>
			<BackToTopButton />
			<div className='app-instructor-profile-cta-wrap'>
				<div className='app-instructor-profile-cta-content-bar' />
				<div className='app-instructor-profile-cta-content-pics'>
					<div className='app-instructor-profile-cta-content-item'>
						{/* <div className='app-instructor-profile-cta-price'>$ {Number(parseInt(instructorProfileData?.price ? instructorProfileData?.price : '0')).toFixed(2)}</div> */}
						<div className='app-instructor-profile-cta-price'>${Number(parseInt(instructorProfileData?.price ? instructorProfileData?.price : '0')).toString()}</div>
						<div className='app-instructor-profile-cta-price-label'>per session</div>
					</div>
					<div className='app-instructor-profile-cta-content-item'>
						<button 
							className={'app-instructor-profile-cta-button'}
							onClick={(event) => { 
								event.stopPropagation()
								bookNowButtonClickHandler()
							}}
						>
							<div className='app-instructor-profile-cta-button-label'>
								Book
							</div>
						</button>
					</div>
					<div className='app-instructor-profile-cta-content-item'>
						<div className='app-instructor-profile-cta-content-item-text'>Pricing<br/>explained</div>
					</div>
				</div>
				<div className='app-instructor-profile-cta-bottom-text'>You won't be charged yet</div>
			</div>
		</>
	)
}

export default AppInstructorProfilePics
